import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import IRestrictTo from '../../types/RetrictTo';
import Validator from '../../utilities/Validator';
import './TextFieldBase.scss';
import ITextFieldBaseProps from './TextFieldBaseProps';

const TextFieldBase = ({
  inputTag,
  onChange,
  value = '',
  type,
  onClick,
  onFocus,
  onBlur,
  onKeyDown,
  error,
  disabled,
  placeholder,
  iconLeft,
  iconRight,
  restrictTo,
  autofocus,
  inputRef,
  autoComplete,
  tabIndex,
  style,
  textAlign,
  className,
}: ITextFieldBaseProps) => {
  const classes = classNames(
    'text-field',
    {
      'text-field-icon-right': iconRight,
      'text-field-icon-left': iconLeft,
    },
    className
  );

  const inputClasses = classNames({
    'disabled': disabled,
    'input-error': error,
    'input-disabled': disabled,
  });

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const val = event.target.value;
    if (!disabled && (!restrictTo || matchesRestriction(val))) {
      onChange?.(val, event);
    }
  }

  function handleClick(event: React.MouseEvent<HTMLInputElement>) {
    if (!disabled && onClick) {
      onClick(event.currentTarget.value, event);
    }
  }

  function handleFocus(event: React.FocusEvent<HTMLInputElement>) {
    if (!disabled && onFocus) {
      onFocus(event.target.value, event);
    }
  }

  function handleBlur(event: React.FocusEvent<HTMLInputElement>) {
    if (!disabled && onBlur) {
      onBlur(event.target.value, event);
    }
  }

  function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if (!disabled && onKeyDown) {
      onKeyDown(event.currentTarget.value, event);
    }
  }

  // checks that the new value passes all restrictions
  function matchesRestriction(val: string) {
    if (restrictTo) {
      return !_.some(Object.keys(restrictTo), (key: keyof IRestrictTo) => {
        const valid = Validator.validate(key, val, restrictTo[key]);
        return valid && valid.hasError;
      });
    } else {
      return true;
    }
  }

  return (
    <div className={classes} onClick={handleClick}>
      {iconLeft}
      {React.createElement(inputTag, {
        className: inputClasses,
        disabled,
        value,
        type,
        autoComplete,
        onChange: handleChange,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        autoFocus: autofocus ? true : false,
        placeholder,
        ref: inputRef,
        tabIndex,
        style: {
          ...style,
          textAlign,
        },
      })}
      {restrictTo && restrictTo['maxLength'] !== undefined && (
        <span className="field-counter">{`${value.length}/${restrictTo.maxLength}`}</span>
      )}
      {iconRight}
    </div>
  );
};

export default TextFieldBase;
